var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classes,on:{"click":function($event){$event.stopPropagation();return _vm.$_onMenuItemClick($event)}}},[_vm._t("default"),_vm._ssrNode(" "),(this.$slots.subNav)?_c('t-dropdown',{attrs:{"offset":"-12px"}},[_vm._t("title",null,{"slot":"trigger"}),_vm._v(" "),_vm._t("subNav",null,{"slot":"popper"})],2):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b5a8ecb","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/navs/navs-item.vue
// module id = 635
// module chunks = 0 1 23